module.exports = __webpack_public_path__ + "img/great.57e95f44.gif";